import { AllHTMLAttributes, forwardRef, useEffect, useState } from 'react';
import { Box, FormHelperText } from '@mui/material';
import clsx from 'clsx';
import { Control, Controller, ControllerProps } from 'react-hook-form';
import PhoneInput, { formatPhoneNumberIntl } from 'react-phone-number-input';
import { ErrorFormField } from '../types';

type PhoneNumberInputProps = AllHTMLAttributes<HTMLInputElement> &
  ErrorFormField & {
    onValueChange?: (num: string | number | readonly string[]) => void;
  };

const PhoneNumberInput = forwardRef((props: PhoneNumberInputProps, ref) => {
  const { className, value, onValueChange, error, errMessage, label = 'Phone number', ...extraProps } = props;

  return (
    <Box className={clsx('flex flex-col ', className)}>
      <Box style={{ height: '56px' }} className="border-form-border-color flex h-[56px] flex-row items-center rounded border px-3">
        <PhoneInput {...extraProps} value={formatPhoneNumberIntl(value as string)} onChange={onValueChange} defaultCountry="GB" smartCaret placeholder={label} />
      </Box>
      {error && (
        <FormHelperText className="mt-1" error={error}>
          {errMessage}
        </FormHelperText>
      )}
    </Box>
  );
});

type ControlledProps = Omit<ControllerProps, 'control' | 'render'> &
  PhoneNumberInputProps & {
    control: Control<any>;
  };

export const PhoneNumberInputControlled = forwardRef(({ control, name, ...props }: ControlledProps, ref) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return <PhoneNumberInput {...props} ref={ref} value={value} onValueChange={onChange} error={!!error} errMessage={error?.message} />;
      }}
    />
  );
});

export default PhoneNumberInput;
